import { TableCell } from "@mui/material";
import React from "react";
import { EditableGridActionTypes } from "../../state/EditableGridActions";
/**
 * A function that renders each cell in the add new row.
 */
export const getAddNewCells = (defaultNewRow, dispatch, getColumnWidth, headerGroups, onRowStartingAdd, state) => {
    //Update new rowdata handler
    const updateRowData = (columnId, value) => {
        const newRow = { ...state.addNewRowData };
        //eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        newRow[columnId] = value;
        dispatch({ type: EditableGridActionTypes.UPDATE_ADD_NEW_ROW_DATA, rowData: newRow });
    };
    return headerGroups.map((headerGroup) => headerGroup.headers.map((column) => {
        const initialValues = { ...state.addNewRowData };
        const rowInstance = {
            //This index is currently being used to determine that this row is the add new row. May change as part of (Work item: 908)
            index: -1,
            values: initialValues,
            original: defaultNewRow,
            canExpand: false
        };
        //Create cell props for the AddNew cells. This is usually generated by react-table for actual rows in the data collection provided.
        //But because this is not part of our data collection, the cell props need to be generated manually.
        const newCellProps = {
            cell: {
                value: state.addNewRowData[column.id],
                row: rowInstance
            },
            row: rowInstance,
            column: {
                id: column.id
            },
            value: state.addNewRowData[column.id],
            addRow: onRowStartingAdd,
            updateRow: updateRowData,
            //The callbacks for the following methods will not be executable on the add new row.
            startRowEdit: () => {
                return;
            },
            endRowEdit: () => {
                return Promise.resolve();
            },
            cancelRowEdit: () => {
                return;
            },
            deleteRow: () => {
                return Promise.resolve();
            },
            state: state
        };
        return (React.createElement(TableCell, { component: "div", key: `add-cell-${column.id}`, 
            //If it is the last cell in the row, style accordingly
            style: {
                ...column.cellEditStyle,
                width: getColumnWidth(column.id) ?? column.pxWidth ?? column.width,
                maxWidth: column.maxWidth,
                minWidth: column.minWidth,
                ...(column.flexGrow && { flexGrow: column.flexGrow, flexShrink: 0 }),
                ...(!(column.flexGrow || column.pxWidth) && { flexGrow: 1, flexShrink: 0 })
            } }, column.CellEdit && column.CellEdit(newCellProps)));
    }));
};
